import { render, staticRenderFns } from "./PeerTube.vue?vue&type=template&id=1810b386"
import script from "./PeerTube.vue?vue&type=script&setup=true&lang=js"
export * from "./PeerTube.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PeerTube.vue?vue&type=style&index=0&id=1810b386&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports